let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9J78C")).then(() => parcelRequire('94DZY'));